/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description detail/modules/nearby
 */

import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { default as rootReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export { whitelist }
export const nearby = filterActions<
  ReturnType<typeof rootReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(rootReducer, whitelist)
